import { render } from "./svg-container.vue?vue&type=template&id=1f7381fe&lang=pug"
import script from "./svg-container.vue?vue&type=script&lang=js"
export * from "./svg-container.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__